export const REPLY_EDITOR_MODES = {
  REPLY: 'REPLY',
  NOTE: 'NOTE',
  // Chatsell: "Correcciones IA" tab — posts a private note tagged with
  // content_attributes.ai_correction so the backend forwards it to the
  // AI assistant to permanently improve the bot.
  CORRECTIONS: 'CORRECTIONS',
};

export const CHAR_LENGTH_WARNING = {
  UNDER_50: 'characters remaining',
  NEGATIVE: 'characters over',
};
